import { render, staticRenderFns } from "./ForChinaSellers.vue?vue&type=template&id=947f89da"
import script from "./ForChinaSellers.vue?vue&type=script&lang=js"
export * from "./ForChinaSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports